import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { ShowToast } from "../../../../helpers/ToastService";
import { PatientAddTeam, PatientgetTeam } from "../../../../api/helper";

const validationSchema = Yup.object().shape({
  facility: Yup.string().required("Facility is required"),
  fromDate: Yup.date()
    .typeError("Please select a valid From Date")
    .required("From Date is required"),
  toDate: Yup.date()
    .typeError("Please select a valid To Date")
    .min(Yup.ref("fromDate"), "To Date cannot be before From Date")
    .required("To Date is required"),
  lastSeenDate: Yup.date()
    .typeError("Please select a valid Last Seen Date")
    .required("Last Seen Date is required"),
});

const FacilityTeam = ({ info, closeModal,Fetchteammember }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    data.patientId = info?._id;
    data.memberType = "facility";
    console.log("Submitted Data:===>>", data);
    try {
      const response = await PatientAddTeam(data);
      // console.log(response?.data, "response======facility---");
      ShowToast(response?.data?.message);
      reset();
      Fetchteammember()
      closeModal();
    } catch (error) {
      console.log(error);
         closeModal();
    }
    closeModal();
  };

  // const Fetchteammember = async () => {
  //   try {
  //     const response = await PatientgetTeam(info?._id);
  //     // console.log(response?.data?.data?.TeamMember, "get======facility---");
  //   } catch (error) {
  //     console.log(error);
  //   }
    
  // };
  // useEffect(() => {
  //   Fetchteammember();
  // }, []);

  return (
    <div id="facility" className="tab-content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <label htmlFor="facility-search-facility">Facility</label>
          <input
            type="search"
            id="facility-search-facility"
            placeholder="Search Facility"
            {...register("facility")}
          />
          {errors.facility && (
            <p className="error-message">{errors.facility.message}</p>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="from-date-facility">From Date</label>
          <input
            type="date"
            id="from-date-facility"
            {...register("fromDate")}
          />
          {errors.fromDate && (
            <p className="error-message">{errors.fromDate.message}</p>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="to-date-facility">To Date</label>
          <input
            type="date"
            id="to-date-facility"
            {...register("toDate")}
          />
          {errors.toDate && (
            <p className="error-message">{errors.toDate.message}</p>
          )}
        </div>
        <div className="form-group">
          <label htmlFor="lastseen-date-facility">Last Seen Date</label>
          <input
            type="date"
            id="lastseen-date-facility"
            {...register("lastSeenDate")}
          />
          {errors.lastSeenDate && (
            <p className="error-message">{errors.lastSeenDate.message}</p>
          )}
        </div>
        <div className="form-buttons">
          <button
            className="cancel"
            type="button"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button className="save" type="submit">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default FacilityTeam;
